import img1 from "../components/Ica.jpeg"
import img2 from "../components/fullDoc.jpeg"
const Cfp = () => {
    return (
        <div className="my-24  lg:px-36 flex justify-center">
            <div class="bg-white  w-full lg:max-w-[80%]">
                <img src={img1} alt="details" className="w-full"></img>
                Technology for Sustainable Development Goals Tech4sdg-2k25 invites researchers, academics, industry professionals, and students to submit original research and innovative solutions addressing the role of technology in advancing the United Nations’ Sustainable Development Goals (SDGs). We aim to foster collaboration and highlight impactful work that contributes to a sustainable and inclusive future.
            </div>
        </div>
    );
}

export default Cfp